---
title: Roddo App Guides
description: App guides for using Roddo's fishing map, catch log, FishIQ, and community features.
---

# Roddo App Guides

Use these guides to understand the main parts of Roddo.

- [Fishing map guide](/learn/fishing-map)
- [Catch log guide](/learn/catch-log)
- [FishIQ guide](/learn/fishiq)
- [Fishing safety reminders](/learn/fishing-safety)

Roddo is built to help anglers plan, remember, and learn without promising certainty.
